export function routes($stateProvider) {
    $stateProvider
        .state('app.pad', {
        url: '/pad',
        abstract: true,
        manutencao: false,
        template: '<div ui-view></div>'
    });
}
routes.$inject = ['$stateProvider'];
